import Navbar from "@/components/honor/Navbar";
import Hero from "@/components/honor/Hero";
import Marquee from "@/components/honor/Marquee";
import Academia from "@/components/honor/Academia";
import ViajeLibertad from "@/components/honor/ViajeLibertad";
import Ranks from "@/components/honor/Ranks";
import Stats from "@/components/honor/Stats";
import Features from "@/components/honor/Features";
import Indicators from "@/components/honor/Indicators";
import Monetizacion from "@/components/honor/Monetizacion";
import AppMovil from "@/components/honor/AppMovil";
import Team from "@/components/honor/Team";
import Partners from "@/components/honor/Partners";
import Plans from "@/components/honor/Plans";
import Testimonials from "@/components/honor/Testimonials";
import CasosExito from "@/components/honor/CasosExito";
import FAQ from "@/components/honor/FAQ";
import Footer from "@/components/honor/Footer";
export default function Landing() {
  return (
    <div className="bg-black text-white overflow-x-hidden" data-testid="landing-page">
      <Navbar />
      <Hero />
      <Marquee />
      <Academia />
      <ViajeLibertad />
      <Ranks />
      <Plans />
      <Monetizacion />
      <Stats />
      <Features />
      <Indicators />
      <AppMovil />
      <Team />
      <Partners />
      <CasosExito />
      <Testimonials />
      <FAQ />
      <Footer />
    </div>
  );
}
